// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"style_rootContainer__mAsMc","headerContainer":"style_headerContainer__3MT85","title":"style_title__1fMD2","subtitle":"style_subtitle__2L2sG"};